// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.I4kO2_S4xqCQKQReCVNJ {
  height: 188px;
  width: 307px;
}

.XnwPcuaF9mwr72bsj0xP {
  width: 100%;
  background-color: var(--grey-color-200);
  height: 1px;
  margin-block-start: 0;
}

.xoAvx8cmn5l7i6hz4zk4 {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  width: 100%;
  gap: 8px;
  padding: 8px 0px;
  align-items: center;
}

.tfuCC79hRkWBzP5oevoU {
  width: 121px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 2px;
}

.qVOaZ__Cp1zpdrYEKD5d {
  position: relative;
  top: -3px;
  font-family: var(--font-stack-full-heavy);
  font-size: 16px;
  line-height: 24px;
  font-weight: 800;
  justify-content: flex-start;
  color: var(--grey-color-70);
}

.n9CVtcfGFfsF1ROLHlAw {
  width: 14px;
  height: 14px;
  border-radius: 14px;
  border-width: 1px;
  border-style: solid;
}`, "",{"version":3,"sources":["webpack://./src/components/DonutChart/DistributionSet.module.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,YAAA;AACF;;AAEA;EACE,WAAA;EACA,uCAAA;EACA,WAAA;EACA,qBAAA;AACF;;AAEA;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,WAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,QAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,yCAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,2BAAA;EACA,2BAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;AACF","sourcesContent":[".container {\n  height: 188px;\n  width: 307px;\n}\n\n.line {\n  width: 100%;\n  background-color: var(--grey-color-200);\n  height: 1px;\n  margin-block-start: 0;\n}\n\n.descriptor {\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: row;\n  width: 100%;\n  gap: 8px;\n  padding: 8px 0px;\n  align-items: center;\n}\n\n.legend {\n  width: 121px;\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.description {\n  position: relative;\n  top: -3px;\n  font-family: var(--font-stack-full-heavy);\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 800;\n  justify-content: flex-start;\n  color: var(--grey-color-70);\n}\n\n.circle {\n  width: 14px;\n  height: 14px;\n  border-radius: 14px;\n  border-width: 1px;\n  border-style: solid;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `I4kO2_S4xqCQKQReCVNJ`,
	"line": `XnwPcuaF9mwr72bsj0xP`,
	"descriptor": `xoAvx8cmn5l7i6hz4zk4`,
	"legend": `tfuCC79hRkWBzP5oevoU`,
	"description": `qVOaZ__Cp1zpdrYEKD5d`,
	"circle": `n9CVtcfGFfsF1ROLHlAw`
};
export default ___CSS_LOADER_EXPORT___;
